import { IDocumentFolderModel } from '@api/models';
import { moveFileToFolder } from '@api/services/document.service';
import { useMemo } from 'react';
import MoveItemDrawer from '../MoveItemDrawer/MoveItemDrawer';

type DocumentFile = {
    _id: string;
    name: string;
    folder?: string | null;
};

interface MoveFileDrawerProps {
    clientId: string;
    folders: IDocumentFolderModel[];
    selectedFile: DocumentFile;
    show: boolean;
    onClose: () => void;
    refetchAll: () => void;
}

const MoveFileDrawer = ({ clientId, folders, selectedFile, show, onClose, refetchAll }: MoveFileDrawerProps) => {
    const initialLocation = useMemo(() => (selectedFile?.folder ?? null) as string | null, [selectedFile]);

    return (
        <MoveItemDrawer
            show={show}
            onClose={onClose}
            refetchAll={refetchAll}
            title="Move File"
            itemName={selectedFile?.name}
            folders={folders}
            initialLocation={initialLocation}
            currentLocationParentId={initialLocation}
            initialBrowseParentId={initialLocation}
            successMessage="File moved successfully."
            onMove={(destinationParentId) =>
                moveFileToFolder(clientId, selectedFile._id, {
                    folder: destinationParentId,
                })
            }
        />
    );
};

export default MoveFileDrawer;
